export default {
  chiefs: { bg: '#2a2a28', text: '#fff' },
  boti: { bg: '#2a2a28', text: '#fff' },
  melissa: { bg: '#d0b4c9', text: '#000' },
  moss: { bg: '#1c2b18', text: '#fff' },
  motorsports: { bg: '#202124', text: '#fff' },
  vw: { bg: '#0d0810', text: '#fff' },
}
